import React from 'react';

import { connectTo } from '../../utils';
import { StatusHeader, StatusTable } from '../../components/status/index.troy';
import { Timeline } from '../../components/home/index.troy';

import styles from './troy.module.scss';

import { PAY_NOW_TEXT_KEY } from '../../constants/payment';

class Status extends React.Component {
  render() {
    const { timeline, timelineBlur, translations } = this.props;
    return (
      <div className={styles['status__wrapper']}>
        <StatusHeader
          payNowLabel={(translations[PAY_NOW_TEXT_KEY] || '').toUpperCase()}
        />
        <StatusTable timeline={timeline} />
        <div className={styles['status__timeline']}>
          <Timeline blur={timelineBlur} items={timeline} />
        </div>
      </div>
    );
  }
}

export default connectTo(
  ({
    liability: { timeline },
    ui: {
      home: {
        blur: { demandTable: demandTableBlur, timeline: timelineBlur }
      }
    },
    translations: { translations }
  }) => ({
    timeline,
    timelineBlur,
    translations
  }),
  {},
  Status
);
